// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1260":"42a4f49d272e8ef5","1599":"42a4f49d272e8ef5","1931":"42a4f49d272e8ef5","3185":"2d4f52089ef3df09"}[chunkId] + ".css";
};